module.exports = __webpack_public_path__ + "faf039753eeb91df307d674addf94160.png";